<h5>Arquivos enviados</h5>

<form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
  <div class="container">
      <div class="float-end botoes">
        <div class="col-auto">
          <button class="btn btn-primary no-margin" type="button" [routerLink]="['/empresas-bloqueadas/cadastro/lote']" >
            <i class="fa fa-upload"></i> Enviar Lote</button>
        </div>
        <div class="float-end botoes">
          <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
        </div>
        <div class="float-end botoes">
          <button #focusableSubmit type="button" [disabled]="!podePesquisar()" class="btn btn-success"
            (keydown.enter)="buscar(false, true)" (click)="buscar(false, true)">Pesquisar</button>
        </div>
     </div>
  </div>
  <div class="container">     
     <h3>Filtros de pesquisa</h3>

    <div class="row">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <ng-select
          id="agenteFinanceiro"
          [items]="agentesFinanceiros"
          bindLabel="nome"
          [multiple]="false"
          [clearable]="true"
          [readonly]="!podeEscolherAgente"
          [clearOnBackspace]="true"
          formControlName="agenteFinanceiro"
          [searchable]="true"
          bindValue="cnpj"
          placeholder="Todos"
          class="auto-grow">
          <ng-template ng-label-tmp let-item="item">
            {{ item.nome }}
          </ng-template>
        </ng-select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="statusProtocolo">Status da solicitação: </label>
        <select id="statusProtocolo" class="form-select" formControlName="statusProtocolo">
          <option [ngValue]="undefined" [selected]="true">Todos</option>
          <option value='A'>Aguardando validação</option>
          <option value='S'>Sucesso</option>
          <option value='E'>Erro</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="statusProtocolo">Id Solicitação API Externa: </label>
        <input type="number" class="form-control" formControlName="idSolicitacaoApiExterna" id="idSolicitacaoApiExterna" />
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataEnvioInicial">Data de envio inicial:</label>
        <bn-datepicker name="dataEnvioInicial" idInput="dataEnvioInicial" formControlName="dataEnvioInicial">
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataEnvioFinal">Data de envio final:</label>
        <bn-datepicker name="dataEnvioFinal" idInput="dataEnvioFinal" formControlName="dataEnvioFinal">
        </bn-datepicker>
      </div>
    </div>
  </div>
</form>

<bn-loading-overlay></bn-loading-overlay>

<app-envio-consulta-protocolo-empresa-listagem [cnpjAgente]="cnpjSelecionado" [protocolos]="protocolosRenuncia"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem" (aoMudarPagina)="mudancaPagina($event)"
  [exibirComboTipoArquivo]="exibirComboTipoArquivo" (exportarProtocolosRenuncia)="exportarProtocolos()" >
</app-envio-consulta-protocolo-empresa-listagem>
